<template>
  <TableEmpty v-if="!loading && users.length === 0" style="top: 50%" />
  <PageScroll
    v-else
    class="-width-limiter-"
    :data="users"
    :is-loading="loading"
    width="100%"
    @incrementPage="incrementPage"
  >
    <Table :nav-titles="navTitles">
      <template #nav="">
        <NavCell
          v-for="title in navTitles"
          :key="title.id"
          :class="{
            '-pointer-': title.sortType !== undefined,
            'investments-table__header': title.id === 3 || title.id === 5
          }"
          @click.native="setSort(title)"
        >
          <span>{{ title.title }}</span>
          <Icon
            v-if="title.sortType !== undefined"
            class="ui-space-table__icon -arrow-"
            icon="ui-down"
            :class="{
              '-active-': title.channelId === sortChannel,
              '-rotate-': title.sortType === 'ASC'
            }"
          />
          <template v-if="title.id === 3">
            <Tooltip class="table-header__tooltip" direction="bottom">
              {{ nicheTooltip }}
            </Tooltip>
          </template>
          <template v-if="title.id === 5">
            <Tooltip class="table-header__tooltip" direction="bottom">
              Чистая прибыль в месяц
            </Tooltip>
          </template>
        </NavCell>
      </template>
      <template v-if="loading && !loadMore">
        <Row
          v-for="i in 5"
          :key="`load-${i}`"
          :loading="true"
          :nav-titles="navTitles"
          load-cell-class="-full-border-"
          height="43px"
        />
      </template>
      <template v-else>
        <div
          v-for="user in users"
          :key="user.id"
          class="rating-investments-table__user-group"
        >
          <div v-if="user.businessNiches.length" class="user-group__container">
            <Row
              v-for="(niche, nicheIndex) in user.businessNiches"
              :key="niche.id + '_' + user.id"
              :nav-titles="navTitles"
              height="43px"
            >
              <Cell
                v-if="nicheIndex === 0"
                class="-pointer- -full-border-"
                :style="{ height: 43 * user.businessNiches.length + 'px' }"
                @click="goTo(user)"
              >
                {{ user.name }}
                {{ user.patronymic }}
                {{ user.lastname }}
              </Cell>
              <Cell
                v-else
                class="-pointer- -full-border-"
                @click="goTo(user)"
              />
              <Cell
                v-if="nicheIndex === 0"
                class="rating-investments-table__city-text"
                :style="{ height: 43 * user.businessNiches.length + 'px' }"
              >
                {{ user.city }}
              </Cell>
              <Cell v-else class="-full-border-" />
              <Cell class="-full-border- niche-table__cell -with-border-">
                <UiCheckbox
                  class="niche-cell__checkbox"
                  :value="niche.verified"
                  @input="markNiche(niche)"
                />
                <div class="niche-cell__text">
                  <div v-tooltip="popupText(niche)">
                    {{ niche.name }}
                  </div>
                  <div class="rating-investments-table__text_sm -gray-">
                    {{ niche.main ? 'Основная,' : '' }} Конкурент:
                    {{ niche.hasRivals ? 'есть' : 'нет' }}
                  </div>
                </div>
                <v-popover
                  class="niche-cell__comment -pointer-"
                  offset="16"
                  placement="bottom"
                  trigger="click"
                  @show="openComments(niche.id)"
                  @hide="clearComments()"
                >
                  <div>
                    <Icon class="tooltip-target" icon="ui-comment" />
                    <sup
                      v-if="niche.comments && niche.comments.length > 0"
                      class="comment-total"
                    >
                      {{ niche.comments.length }}
                    </sup>
                  </div>
                  <template #popover>
                    <CommentsPopover :can-edit="canEdit" :niche-id="niche.id" />
                  </template>
                </v-popover>
              </Cell>
              <Cell
                v-if="nicheIndex === 0"
                class="-full-border-"
                :class="{
                  'ui-space-table__col--empty': !user.configurations.length
                }"
                :style="{ height: 43 * user.businessNiches.length + 'px' }"
              >
                <template v-if="user.configurations[0]">
                  {{ user.configurations[0].pointA | numberFormat }} ₽
                </template>
                <template v-else> Нет данных </template>
              </Cell>
              <Cell v-else class="-full-border-" />
              <Cell
                v-if="nicheIndex === 0"
                class="-full-border-"
                :class="{
                  'ui-space-table__col--empty': !user.configurations.length
                }"
                :style="{ height: 43 * user.businessNiches.length + 'px' }"
              >
                <template v-if="user.configurations[0]">
                  {{ user.configurations[0].profit | numberFormat }} ₽
                </template>
                <template v-else> Нет данных </template>
              </Cell>
              <Cell v-else class="-full-border-" />
              <Cell
                v-if="nicheIndex === 0"
                class="-full-border-"
                :style="{ height: 43 * user.businessNiches.length + 'px' }"
              >
                <span style="color: #6979f8">{{ user.totalPassed }}</span> /
                {{ user.totalPlanned }}
              </Cell>
              <Cell v-else class="-full-border-" />
              <Cell
                v-if="nicheIndex === 0"
                class="-full-border-"
                :style="{ height: 43 * user.businessNiches.length + 'px' }"
              >
                {{ user.totalAmount | numberFormat }} ₽
              </Cell>
              <Cell v-else class="-full-border-" />
            </Row>
          </div>
          <div v-else class="user-group__container">
            <Row :nav-titles="navTitles" height="43px">
              <Cell class="-pointer- -full-border-" @click="goTo(user)">
                {{ user.name }}
                {{ user.patronymic }}
                {{ user.lastname }}
              </Cell>
              <Cell class="rating-investments-table__city-text">
                {{ user.city }}
              </Cell>
              <Cell class="-full-border- niche-table__cell -with-border-">
                <UiCheckbox
                  class="niche-cell__checkbox"
                  :value="false"
                  disabled
                />
                <div class="niche-cell__text niche-cell__text--empty">
                  <div>Нет данных</div>
                </div>
              </Cell>
              <Cell
                class="-full-border-"
                :class="{
                  'ui-space-table__col--empty': !user.configurations.length
                }"
              >
                <template v-if="user.configurations[0]">
                  {{ user.configurations[0].pointA | numberFormat }} ₽
                </template>
                <template v-else> Нет данных </template>
              </Cell>
              <Cell
                class="-full-border-"
                :class="{
                  'ui-space-table__col--empty': !user.configurations.length
                }"
              >
                <template v-if="user.configurations[0]">
                  {{ user.configurations[0].profit | numberFormat }} ₽
                </template>
                <template v-else> Нет данных </template>
              </Cell>
              <Cell class="-full-border-">
                <span style="color: #6979f8">{{ user.totalPassed }}</span> /
                {{ user.totalPlanned }}
              </Cell>
              <Cell class="-full-border-">
                {{ user.totalAmount | numberFormat }} ₽
              </Cell>
            </Row>
          </div>
          <div class="user-group__delimiter" />
        </div>
      </template>
      <Row
        v-if="loadMore"
        :key="`load-more`"
        :loading="true"
        :nav-titles="navTitles"
        load-cell-class="-full-border-"
        height="43px"
      />
    </Table>
  </PageScroll>
</template>

<script>
import { mapState } from 'vuex';

import Table from '../../components/Table';
import Row from '../../components/Table/Row';
import Cell from '../../components/Table/Cell';
import NavCell from '../../components/Table/NavCell';
import Tooltip from '../../components/Tooltip';
import UiCheckbox from '@/components/UiKit/Checkbox';
import CommentsPopover from '@/views/Rating/Investments/components/CommentsPopover';

export default {
  components: {
    CommentsPopover,
    Table,
    Row,
    Cell,
    NavCell,
    Tooltip,
    UiCheckbox
  },
  props: {
    filter: {
      type: Object,
      default: undefined
    },
    sortChannel: {
      type: String,
      default: undefined
    },
    streamFilter: {
      type: Number,
      default: undefined
    },
    navTitles: {
      type: Array,
      default: undefined
    }
  },
  data: () => ({
    loadMore: false,
    nicheTooltip: `Нишу участника необходимо подтвердить галочкой.
    Комментарии можно оставлять, нажав на иконку сообщения`
  }),
  computed: {
    ...mapState('ratingInvestments', {
      users: s => s.data.users,
      page: s => s.data.page,
      folders: s => s.data.folders,
      isLoading: s => s.meta.isLoading,
      isLoadingPage: s => s.meta.isLoadingPage,
      noMorePage: s => s.meta.noMorePage
    }),
    isAdmin() {
      return (
        this.$store.state['auth'].data.user.permissions.isAdmin ||
        this.$store.state['auth'].data.user.permissions.analyticsModelAdmin
      );
    },
    canEdit() {
      return (
        this.$store.state['auth'].data.user.permissions.isAdmin ||
        this.$store.state['auth'].data.user.permissions.analyticsModelAdmin
          .update !== 0
      );
    },
    loading() {
      return this.isLoading || this.isLoadingPage;
    }
  },
  methods: {
    goTo(user) {
      if (!this.isAdmin) {
        return;
      }
      this.$router.push({ path: `/rating/unified/user/${user.id}` });
    },
    async incrementPage() {
      this.loadMore = true;
      await this.$store.dispatch('ratingInvestments/getUserList', this.filter);
      this.loadMore = false;
    },
    getUserChanel(user, id) {
      const chanel = user.info.find(({ channelId }) => channelId === id);
      return chanel ? chanel.fullProfit : 0;
    },
    setSort(title) {
      if (title.channel === undefined && title.sortType === undefined) {
        return;
      }
      this.$emit('setSort', title);
    },
    openComments(nicheId) {
      this.$store.dispatch('ratingInvestments/setComments', nicheId);
    },
    clearComments() {
      this.$store.dispatch('ratingInvestments/clearComments');
    },
    markNiche(niche) {
      if (this.canEdit) {
        this.$store.dispatch('ratingInvestments/markNiche', niche);
      }
    },
    popupText(niche) {
      return `${niche.name}

      ${niche.description || 'Описание отсутствует'}`;
    }
  }
};
</script>
